import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';

export const getVesselTypesQuery = gql`
  query vesselTypes($breweryId: Int!) {
    vesselTypes(breweryId: $breweryId) {
      id
      name
    }
  }
`;

const VesselTypeOptions = ({ brewery }) => (
  <Query query={getVesselTypesQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <option>...</option>;
      }

      if (error) {
        return <option>Sorry, there was an error getting the vessel types</option>;
      }

      return (
        <Fragment>
          <option>Select a vessel type</option>
          {data.vesselTypes.map(type => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(VesselTypeOptions);



// WEBPACK FOOTER //
// ./src/containers/vesselTypeOptions/vesselTypeOptions.jsx